<template>
  <div v-if="show" class="recharge-popup-container van-overlay" style="z-index: 99;" @click="handleExitRecharge">
    <div class="inner-container" @click.stop="()=>{}">
      <div class="popup-header-item">余额充值</div>
      <div class="input-item flex">
        <div class="name-item">{{ selectedObj && selectedObj.Id == -1 ? '充值卡密' : '充值金额' }}</div>
        <div class="input">
          <input v-model="money" :type="selectedObj.Id != -1 ? 'number' : 'text'" :placeholder="selectedObj && selectedObj.Id == -1 ? '请输入充值卡密' : '请输入充值金额'" />
        </div>
      </div>
      <div v-if="selectedObj && selectedObj.Id != -1" class="tip-item">{{ ('充值金额' + (selectedObj.Min ? '最低' + selectedObj.Min : '') + (selectedObj.Max ? '最高' + selectedObj.Max : '')) }}</div>
      <div class="input-item">
        <div class="name-item">支付方式</div>
        <div class="pay-types">
          <div class="item" :class="selectedObj && selectedObj.Id == item.Id ? 'active' : ''" v-for="(item, index) in paymentList" :key="index" @click="handleChoosePayment(item)">
            <div class="icon img-cover">
              <img v-if="item.Paytype == 1" src="../../assets/pc-images/paytype1-icon.png" />
              <img v-if="item.Paytype == 2" src="../../assets/pc-images/paytype2-icon.png" />
              <img v-if="item.Paytype == 3" src="../../assets/pc-images/paytype3-icon.png" />
            </div>
            <div class="name">
              <div class="title">{{ item.Payname }}</div>
              <!-- <div class="sub-tiitle" v-if="item.Sxf">({{ item.Sxf }}%手续费)</div> -->
            </div>
          </div>
          <div v-if="!showKm" class="item" :class="selectedObj && selectedObj.Id == -1 ? 'active' : ''" @click="handleChoosePayment({Id: -1})">
            <div class="icon img-cover">
              <img src="../../assets/images/km-icon.png" />
            </div>
            <div class="name">卡密支付</div>
          </div>
        </div>
      </div>
      <div class="submit-btn" @click="handleSubmit">立即充值</div>
      <div class="cz-tip">{{ czTip ? czTip : '有问题请联系客服' }}</div>
    </div>
    <van-popup v-model="showQRCode" :round="true" position="center" @close="handleClosePopup">
      <div class="popup" @click.stop="()=>{}">
        <div class="title">付款码</div>
        <div class="img img-contain" ref="qrcode"></div>
        <div class="btn-item public-btn" @click="handleClosePopup">确定</div>
      </div>
    </van-popup>
    <van-popup v-model="sdPayPopup.show" :round="true" position="center" @close="handleCloseSdPayPopup">
      <div class="popup" @click.stop="()=>{}">
        <div class="money">¥ <span>{{ sdPayPopup.money }}</span></div>
        <div class="title">付款码</div>
        <div class="img img-contain"><img :src="sdPayPopup.img" /></div>
        <div class="title">识别码(点击识别码复制)</div>
        <div class="code" @click="handleCopy(sdPayPopup.remark)">{{ sdPayPopup.remark }}</div>
        <div class="btn-item public-btn" @click="handleCloseSdPayPopup">确定</div>
      </div>
    </van-popup> 
    <van-popup v-model="showSuccess" :round="true" position="center">
      <div class="success-popup" @click.stop="()=>{}">
        <div class="icon img-cover"><img src="../../assets/images/success-icon.png"></div>
        <div class="title">充值成功</div>
        <div class="btn public-btn" @click="showSuccess = false">确定</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
export default {
  emits: ['success', 'close'],
  name: "RechargeComponent",
  data() {
    return {
      show: false,
      showKm: false,
      czTip: '',
      submiting: false,
      money: '',
      paymentList: [],
      selectedObj: {},
      dmfTimer: null,
      showQRCode: false,
      sdPayPopup: {
        show: false,
        img: '',
        remark: '',
        money: ''
      },
      showSuccess: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  methods: {
    handleExitRecharge() {
      this.show = false
      this.$emit('close')
    },
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    handleChoosePayment(item) {
      this.selectedObj = item
    },
    open() {
      this.show = true
      this.getSetting()
      this.handleGetPayment()
    },
    async getSetting(){
      var res = await this.$API.getSets.post({
        Key: 'cz_remind,is_km'
      })
      this.czTip = res.cz_remind
      this.showKm = res.is_km == 1
    },
    async handleGetPayment() {
      var res = await this.$API.payment.post()
      if (res.info && res.info.length > 0) {
        this.selectedObj = res.info[0]
      }
      this.paymentList = res.info
    },
    async handleSubmit() {
      const { money, selectedObj, submiting } = this
      if (submiting) {
        return
      }
      if (!money && selectedObj.Id == -1) {
        this.$toast('请输入充值卡密')
        return
      }
      if (!money) {
        this.$toast('请输入充值金额')
        return
      }
      if (parseFloat(money) > parseFloat(selectedObj.Max)) {
        this.$toast('充值金额最高' + selectedObj.Max)
        return
      }
      if (parseFloat(money) < parseFloat(selectedObj.Min)) {
        this.$toast('充值金额最低' + selectedObj.Min)
        return
      }
      const params = {}
      let remark = ''
      if (selectedObj.Id == -1) {
        params.Code = money
        params.Switch = 1
      } else {
        params.Money = money
        params.PaymentId = selectedObj.Id
        params.PayType = selectedObj.Paytype
        if (selectedObj.Type == 1) {
          params.Switch = 2
        }
        if (selectedObj.Type == 2) {
          params.Switch = 3
          remark = this.$TOOL.generateRandomNumber(8)
          params.Remark = remark
        }
        if (selectedObj.Type == 3 || selectedObj.Type == 4) {
          params.Switch = 4
        }
        if (selectedObj.Type == 5) {
          params.Switch = 5
        }
      }
      this.submiting = true
      var res = await this.$API.pay.post(params)
      this.submiting = false
      if (res.error == 0) {
        if (selectedObj.Type == 3 || selectedObj.Type == 1) {
          window.location.href = res.info
        } else if (selectedObj.Type == 5 || selectedObj.Type == 4) {
          this.handleSetPopup(res.info, res.orderNo || '')
        } else if (selectedObj.Type == 2) {
          this.sdPayPopup = {
            show: true,
            img: selectedObj.Vendorid,
            remark,
            money
          }
        } else {
          this.showSuccess = true
          this.GetUserInfo()
        }
      } else {
        this.$dialog.alert({
          type: 'danger',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    },
    handleSetPopup(url, OrderNo) {
      this.showQRCode = true
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = ''
        new QRCode(this.$refs.qrcode, {
          text: url,
          width: 240,
          height: 240,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      }, 1000);
      if (OrderNo) {
        if (this.dmfTimer) {
          clearInterval(this.dmfTimer)
        }
        this.dmfTimer = setInterval(async () => {
          var res = await this.$API.reOrder.post({
            OrderNo: OrderNo
          })
          if (res.info.Status != 2) {
            this.handleClosePopup()
            this.showSuccess = true
            // this.$router.push({path: '/success'})
          }
        }, 1000)
      }
    },
    handleCloseSdPayPopup() {
      this.sdPayPopup.show = false
      this.GetUserInfo()
      this.$dialog.alert({
        type: 'danger',
        title: '提示',
        message: '确认成功，请及时联系客服充值',
        confirmButtonText: '确定',
      })
    },
    handleClosePopup() {
      this.showQRCode = false
      this.GetUserInfo()
      if (this.dmfTimer) {
        clearInterval(this.dmfTimer)
        this.dmfTimer = null
      }
    }
  }
}
</script>

<style lang="less" scoped>
.inner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 375px;
  min-height: 275px;
  background-color: #fff;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  padding: 15px;
  .popup-header-item {
    margin-bottom: 8px;
    padding: 5px 0 15px 18px;
    position: relative;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #5783fc;
    border-bottom: 1px solid #e5e5e5;
    &::before {
      content: '';
      position: absolute;
      top: 5px;
      left: 0;
      width: 5px;
      height: 25px;
      border-radius: 3px;
      background-color: #5783fc;
    }
  }
  .input-item {
    padding: 10px 0;
    .name-item {
      width: 80px;
      color: #383838;
      &::before {
        content: '*';
        color: #d43030;
      }
    }
    .input {
      flex: 1;
      border: 1px solid #e5e5e5;
      border-radius: 2px;
      padding: 0 10px;
      height: 20px;
    }
    .pay-types {
      margin-top: 10px;
      overflow: hidden;
      .item {
        cursor: pointer;
        float: left;
        margin-right: 15px;
        margin-bottom: 15px;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        width: 90px;
        height: 35px;
        padding: 0 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.active {
          border-color: #5783fc;
          color: #5783fc;
        }
        .icon {
          width: 25px;
          height: 25px;
          margin-right: 10px;
        }
        .name {
          line-height: 12px;
          font-size: 10px;
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
  .tip-item {
    font-size: 12px;
    color: #ff2442;
    line-height: 16px;
  }
  .cz-tip {
    font-size: 12px;
    color: #999;
  }
  .submit-btn {
    margin: 0 auto 10px;
    width: 120px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background-color: #5783fc;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
}
.popup {
  width: 350px;
  height: 390px;
  box-sizing: border-box;
  border-radius: 16px 16px 0 0;
  background-color: #fff;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  .money {
    font-size: 14px;
    font-weight: bold;
    color: #222;
    margin-bottom: -10px;
    span {
      font-size: 27px;
    }
  }
  .code {
    font-size: 15px;
    color: #333;
    line-height: 22px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .title {
    padding-top: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    line-height: 24px;
  }
  .img {
    width: 160px;
    height: 160px;
    canvas {
      width: 100%;
      height: 100%;
    }
  }
  .btn-item {
    width: 120px;
    height: 35px;
    color: #fff;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
.success-popup {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .icon {
    width: 80px;
    height: 80px;
  }
  .title {
    margin-top: 24px;
    color: #030304;
    font-size: 16px;
    font-weight: 500;
  }
  .btn {
    margin-top: 10px;
    width: 240px;
    height: 40px;
    border-radius: 6px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }
}
</style>